module.exports = __webpack_public_path__ + "img/banner.c5d72f30.png";